// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var listItem = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.rem(1.0)),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.rem(1.0)),
      BsCssJs$PrezzeeRibbon.borderBottom(BsCssJs$PrezzeeRibbon.px(1), "solid", Theme__Color$PrezzeeRibbon.Personal.paleGrey),
      BsCssJs$PrezzeeRibbon.selector("a", [
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0)),
            BsCssJs$PrezzeeRibbon.textDecoration("none"),
            BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.darkGrey)
          ]),
      BsCssJs$PrezzeeRibbon.selector("&:last-of-type", [BsCssJs$PrezzeeRibbon.borderBottomWidth(BsCssJs$PrezzeeRibbon.px(0))])
    ]);

var Styles = {
  listItem: listItem
};

function SearchBar__ListItem(props) {
  return JsxRuntime.jsx("li", {
              children: props.children,
              className: listItem
            });
}

var make = SearchBar__ListItem;

export {
  Styles ,
  make ,
}
/* listItem Not a pure module */
